import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ArrowUp } from 'lucide-react';

export function ScrollToTop() {
  const { pathname } = useLocation();
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      setShowButton(docHeight > 0 && scrollY / docHeight > 0.3);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      {showButton && (
        <div className="fixed bottom-24 right-6 sm:bottom-24 sm:right-6 z-50 flex flex-col items-center">
          <button
            onClick={handleClick}
            aria-label="Scroll to top"
            className="bg-white text-gray-900 hover:bg-yellow-300 hover:text-black border border-gray-200 shadow-lg rounded-full w-12 h-12 flex items-center justify-center transition-colors duration-200 group focus:outline-none"
          >
            <ArrowUp className="w-6 h-6 group-hover:scale-110 transition-transform duration-200" strokeWidth={3} />
          </button>
          <span className="mt-2 text-xs text-black select-none">Go to top</span>
        </div>
      )}
    </>
  );
}